// extracted by mini-css-extract-plugin
export default {"pull-quote":"rxKC2q","pull-quote__quote-icon":"_6gx9d","pull-quote__content":"MIfipW"};